import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-refresh",
  "use": "icon-refresh-usage",
  "viewBox": "0 0 1000 1000",
  "content": "<symbol viewBox=\"0 0 1000 1000\" id=\"icon-refresh\"><path d=\"M486 864v-1l-87-135q-4-8-13-10t-17 2l-7 4q-8 5-8.5 14t4.5 17l55 86-14-3q-73-19-132-66.5T173 657q-32-63-38-133t15.5-137.5 68-121T329 179q10-6 14-17.5t-1.5-22.5-17-14.5T302 126q-75 39-129 101.5T94 369 76 529.5 121 684q41 78 109.5 133T384 895h4l-76 39q-8 4-10.5 12.5T304 963l3 7q5 8 12 10.5t15-2.5l140-71 10-6q8-4 10-12.5t-2-15.5l-6-10v1zm393-545q-41-78-108.5-133T619 109l-25-5 76-38q8-5 11-13t-1-16l-3-8q-5-7-13.5-9.5T647 21L497 99q-8 4-10 12.5t2 15.5l93 145q4 8 13 10t17-2l7-5q7-4 8-13t-4-17l-55-86q19 2 36 7 72 19 130 66t93 114q32 64 38 133.5T849.5 617 783 739t-109 86q-10 6-14 17.5t2 22.5q4 7 11 11t14.5 4 13.5-3q74-38 126.5-100.5t78-141.5T924 474.5 879 319z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/refresh.svg
// module id = 1134
// module chunks = 2